import Vue from "vue";
import Vuex from "vuex";
import { Season } from "@/utils/Seasons";

Vue.use(Vuex);

const defaultFilterState = () => ({
    speedSelected: [],
    accelerationsSelected: [],
    decelerationsSelected: [],
    timesSelected: [],
    anglesSelected: [],
    longitudinalView: false,
    seasonSelected: Season.ALL,
    range: {
        start: new Date(),
        end: new Date()
    },
    updateKey: 0
});

const state = defaultFilterState();

const mutations = {
    SET_FILTERS(state, filters) {
        Object.assign(state, filters);
    },
    RESET_FILTERS(state) {
        Object.assign(state, defaultFilterState());
    },
    TRIGGER_FILTER_UPDATE(state) {
        state.updateKey++; // increment to trigger watchers
    }
};

export default new Vuex.Store({
    state,
    mutations
});
